import React, { use, useEffect, useState } from 'react';
import NotificationsCaughtUpPlaceholder from 'components/NotificationsCaughtUpPlaceHolder';
import NotificationOffPlaceHolder from 'components/NotificationOffPlaceHolder';
import { getTimeSince } from 'utilities';
import { removeUserNotifications } from 'actions/Notifications';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import * as ACTIONS_APP from 'actions/App';


const NotificationsDisplayList = ({ notifications, selectedTab, myFacility, dismissAllNotificationsState, dismissFacilityNotificationsState }) => {
    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    const intl = useIntl();
    const authUser = useSelector((state) => state.auth.authUser);
    const [siteCityMap, setCityMap] = useState({});
    const facility = useSelector((state) => state.reports.myFacility);
    const notificationsCount = useSelector((state) => state.app.notificationsCount);

    // Helper function to parse and format feedback notification body
    const formatFeedbackBody = (body) => {
        // Remove "Feedback - " prefix if it exists
        const cleanBody = body.replace(/^Feedback - /, '');
        
        // Extract Name, Rating, and Comments
        const nameMatch = cleanBody.match(/Name:\s*([^R]+?)(?=Rating:|$)/);
        const ratingMatch = cleanBody.match(/Rating:\s*(\d+)/);
        const commentsMatch = cleanBody.match(/Comments:\s*(.+)/);
        
        const name = nameMatch ? nameMatch[1].trim() : '';
        const rating = ratingMatch ? parseInt(ratingMatch[1]) : 0;
        const comments = commentsMatch ? commentsMatch[1].trim() : '';
        
        // Convert rating number to asterisks
        const ratingStars = '★'.repeat(rating);
        
        return { name, rating: ratingStars, comments };
    };

    useEffect(() => {
        let map = {};
        authUser.sites.forEach((site) => {
            map[String(site.id)] = site;
        });
        setCityMap(map);

        if (notifications !== null && notifications.length > 0 && notifications[0]) {
            // Filter notifications based on the selected facility
            if (myFacility && selectedTab !== 'all') {
                let d = notifications.filter((notification) => {
                    if (notification.siteID && myFacility && myFacility.id) {
                        if (notification.siteID === myFacility.id) {
                            return true;
                        }
                    }
                    return false;
                });
                setData(d);
                
            } else {
                setData(notifications);
            }
        } else {
            setData([]);
        }

        return () => {
            setData([]);
        };
    }, [selectedTab]);
    useEffect(() => {
        if (dismissAllNotificationsState) {
            // Handle notifications update
            setData([]);
        }
        if (dismissFacilityNotificationsState) {
            setData((prevData) => prevData.filter((n) => n.siteID !== myFacility.id));
        }
    }, [dismissAllNotificationsState, dismissFacilityNotificationsState]);

    const dismissNotification = (notification) => {
        dispatch(removeUserNotifications([String(notification.id)], true));
        let d = data.filter((n) => n.id !== notification.id);
        if (d.length === 0) {
            setData([]);
        } else {
            setData(d);
        }
        dispatch(ACTIONS_APP.setNotificationsCount(notificationsCount - 1));
    };

    if (!data || data.length === 0) {
        if (authUser && facility && facility.notifications_on === 'false' && selectedTab === 'facility') {
            return (
                <div className="flex flex-col items-center justify-center h-full w-full gap-4">
                    <NotificationOffPlaceHolder />
                </div>
            );
        } else {
            return (
                <div className="flex flex-col items-center justify-center h-full w-full gap-4">
                    <NotificationsCaughtUpPlaceholder />
                </div>
            );
        }
    } else {
    }
    return (
        <div className="max-h-full custom-scrollbar overflow-y-auto pr-4">
            {Array.isArray(data) &&
                data.length > 0 &&
                data.map(
                    (notification, idx) =>
                        notification && (
                            <div className="flex flex-col flex-1" key={notification.id || idx}>
                                <div className="self-stretch inline-flex flex-col justify-start items-start">
                                    <div
                                        data-option="Button_description"
                                        className="self-stretch py-5 inline-flex justify-between items-center">
                                        <div className="flex-1 pr-4 pl-4 flex justify-start items-center gap-4">
                                            <div
                                                data-option="20pt"
                                                className="p-3 bg-gray-50 rounded-md flex justify-start items-center gap-2">
                                                <div className="w-5 h-5 relative float-left overflow-hidden">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none">
                                                        <path
                                                            d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"
                                                            stroke="#B6B6B6"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M14.1667 9.99998H12.5L10.8334 14.1666L9.16671 5.83331L7.50004 9.99998H5.83337"
                                                            stroke="#B6B6B6"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className="flex-1 flex flex-col justify-start items-start gap-1">
                                                <div className="w-full text-gray-800 text-lg font-semibold leading-none tracking-tight">
                                                    {notification.title === 'New Feedback Received' ? (
                                                        (() => {
                                                            const { name, rating, comments } = formatFeedbackBody(notification.body);
                                                            return (
                                                                <div className="flex flex-col gap-1">
                                                                    <div>Name: {name}</div>
                                                                    <div>Rating: {rating}</div>
                                                                    <div>Comments: {comments}</div>
                                                                </div>
                                                            );
                                                        })()
                                                    ) : (
                                                        notification.body
                                                    )}
                                                </div>
                                                <div className="w-full flex items-center">
                                                    <div className="flex-1 h-6 py-1.5 flex items-center gap-2">
                                                        <div className="flex-1 text-gray-600 text-base font-normal leading-none tracking-tight">
                                                            {selectedTab === 'all' &&
                                                                notification.siteID &&
                                                                siteCityMap[notification.siteID] && (
                                                                    <>
                                                                        <b className="text-gray-800">
                                                                            {siteCityMap[notification.siteID].name}
                                                                        </b>{' '}
                                                                        -{' '}
                                                                    </>
                                                                )}
                                                            {getTimeSince(
                                                                notification.createdDate,
                                                                authUser,
                                                                siteCityMap[notification.siteID],
                                                                siteCityMap[notification.siteID]?.timezone,
                                                                false
                                                            ) || '5 mins. ago'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => dismissNotification(notification)}
                                            className="h-10 px-5 py-3.5 bg-white rounded-full cursor-pointer outline outline-1 outline-offset-[-1px] outline-gray-100 flex items-center gap-2">
                                            <span className="text-gray-800 text-base font-semibold leading-none">
                                                {intl.formatMessage({ id: 'pages.users.dismissTraining' })}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                )}
            {(!Array.isArray(data) || data.length === 0) && (
                <div className="flex flex-col items-center justify-center h-full w-full gap-4">
                    <NotificationsCaughtUpPlaceholder />
                </div>
            )}
        </div>
    );
};

export default NotificationsDisplayList;
